export default function TrustedEcosystems() {
  const ecosystems = [
    { name: 'Apple', icon: 'ri-apple-fill' },
    { name: 'Google Play', icon: 'ri-google-play-fill' },
    { name: 'AWS', icon: 'ri-amazon-fill' },
    { name: 'Meta', icon: 'ri-meta-fill' },
    { name: 'Bubble', icon: 'ri-bubble-chart-line' },
    { name: 'Glide', icon: 'ri-layout-grid-line' },
    { name: 'Adalo', icon: 'ri-apps-line' },
    { name: 'Product School', icon: 'ri-graduation-cap-line' },
    { name: 'No-Code Founders', icon: 'ri-code-s-slash-line' },
    { name: 'YC Startup Library', icon: 'ri-book-open-line' }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            Trusted Across the World's Leading App Ecosystems
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            CrowdRounds integrates with the platforms founders already build and launch on.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 items-center">
          {ecosystems.map((ecosystem, index) => (
            <div
              key={index}
              className="flex flex-col items-center justify-center p-6 bg-white rounded-xl border border-slate-200 hover:border-teal-400 hover:shadow-lg transition-all duration-300 group"
            >
              <div className="w-16 h-16 flex items-center justify-center mb-3">
                <i className={`${ecosystem.icon} text-4xl text-slate-700 group-hover:text-teal-600 transition-colors duration-300`}></i>
              </div>
              <span className="text-sm font-semibold text-slate-700 text-center">
                {ecosystem.name}
              </span>
            </div>
          ))}
        </div>

        <p className="text-center text-sm text-slate-500 mt-12 max-w-2xl mx-auto">
          Ecosystem alignment only — not claiming partnership or endorsement
        </p>
      </div>
    </section>
  );
}
